import { LongRatings, ShortRatings } from '../models'

export const formatRating = (rating: ShortRatings | LongRatings): string => (rating === 'Z' ? 'Unrated' : rating)
